<template>
  <el-dialog
    title="上传"
    :visible.sync="addSuppleQualificationsVisible"
    class="small-dialog"
    v-dialogDrag
    :before-close="cancel"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form ref="suppleQualificationsRef" label-width="150px" :model="suppleQualificationsForm">
      <el-form-item
        label="资质类型/名称"
        prop="categoryCode"
        :rules="[
          {
            required: true,
            message: '请选择资质类型/名称',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-select
          v-model="suppleQualificationsForm.categoryCode"
          size="small"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in workPermitCategoryList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="有效期"
        prop="date"
        :rules="[
          {
            required: true,
            message: '请选择有效期',
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-date-picker
          v-model="suppleQualificationsForm.date"
          type="daterange"
          size="small"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="证书编号"
        prop="number"
        :rules="[{ required: true, message: '请输入证书编号', trigger: 'blur' }]"
      >
        <el-input
          v-model="suppleQualificationsForm.number"
          maxlength="50"
          placeholder="请输入证书编号"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="附件" prop="fileId" ref="fileId">
        <form-upload
          v-model="suppleQualificationsForm.fileId"
          :limit="1"
          :accept="['jpg', 'png', 'doc', 'docx', 'pdf', 'xlsx', 'xls']"
          @change="fileIdChange('fileId')"
          class="w-440px"
        ></form-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="flex justify-center">
      <el-button size="small" type="primary" @click="save" :loading="loading">保存</el-button>
      <el-button size="small" @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import utils from '@/components/safety/enumField/utils'
import FormUpload from '@/components/safety/FileUpload/FormUpload'
import { WorkPermitAddtionalGuidanceConfigurationDirectoriesApi } from '@wiz-api/contractor-management'
import dayjs from 'dayjs'

const workPermitAddtionalGuidanceConfigurationDirectorysApi = new WorkPermitAddtionalGuidanceConfigurationDirectoriesApi()
export default {
  components: {
    FormUpload,
  },
  model: {
    prop: 'addSuppleQualificationsVisible',
    event: 'addSuppleQualificationsChange',
  },
  props: {
    addSuppleQualificationsVisible: {
      type: Boolean,
      default: false,
    },
    workPermitCategoryList: {
      type: Array,
      default: () => {
        return []
      },
    },
    workPermitId: {
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      suppleQualificationsForm: {},
      taskFrequencyType: [],
    }
  },
  methods: {
    fileIdChange(key) {
      this.$refs[key].$emit('el.form.change')
    },
    cancel() {
      this.suppleQualificationsForm = {}
      this.$refs.suppleQualificationsRef.resetFields()
      this.$emit('addSuppleQualificationsChange', false)
    },
    save() {
      this.$refs.suppleQualificationsRef.validate(async (valid) => {
        if (valid) {
          if (this.suppleQualificationsForm.date.length) {
            this.suppleQualificationsForm.validDateBegin = dayjs(
              this.suppleQualificationsForm.date[0]
            ).format('YYYY-MM-DD HH:mm:ss')
            this.suppleQualificationsForm.validDateEnd = dayjs(
              this.suppleQualificationsForm.date[1]
            ).format('YYYY-MM-DD HH:mm:ss')
          }
          this.loading = true
          const [err, res] = await workPermitAddtionalGuidanceConfigurationDirectorysApi.create({
            body: {
              ...this.suppleQualificationsForm,
              workPermitId: this.workPermitId,
            },
          })
          if (!err) {
            this.cancel()
          }
          this.loading = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-dragger {
  height: 130px !important;
  width: 440px !important;
  .el-icon-upload {
    margin: 18px 0 16px;
  }
}
</style>
